module.exports = __webpack_public_path__ + "img/logo_chunliu.10fca20d.png";